import { useEffect } from 'react';
// assets
import { ReactComponent as CloseIcon } from '../../assets/button/close.svg';
// styles
import { Overlay, Wrapper, Close, Title, Content, ScrollBar } from './styles';

// ----------------------------------------------------------------------

interface Props {
  handleClose: () => void;
  title?: string;
  children: React.ReactNode;
  chart?: boolean;
};

// ----------------------------------------------------------------------

export default function Dialog({ handleClose, title, children, chart }: Props){

  useEffect(() => {
    document.body.style.cssText =
    document.body.clientHeight < document.body.scrollHeight ?
    `
      position: fixed; 
      top: -${window.scrollY}px;
      overflow-y: scroll;
      width: 100%;
    ` : `
      overflow: hidden;
    `;

    return () => {
      const scrollY = document.body.style.top;
      document.body.style.cssText = "";
      window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
    };
  }, []);

  return (
    <Overlay>
      <Wrapper $chart={chart}>
        <Close type='button' onClick={() => handleClose()}>
          <CloseIcon />
        </Close>

        <Title>{ title }</Title>

          <Content>
          <ScrollBar>
            { children }
            </ScrollBar>
          </Content>
      </Wrapper>
    </Overlay>
  );
}